<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-info mb-0" role="alert" *ngIf="!hasAvailableActions()">
      This membership has ended and there are no actions available for it.
    </div>

    <div class="form-group" *ngIf="hasAvailableActions()">
      <label for="actionSelect">Action</label>
      <select class="custom-select" id="actionSelect" [(ngModel)]="selectedAction">
        <option [ngValue]="null">
          ---
        </option>
        <option [ngValue]="ActionList.cancel"
                *ngIf="actionIsAvailable(ActionList.cancel)">
          Cancel
        </option>
        <option [ngValue]="ActionList.freezeImmediately"
                *ngIf="actionIsAvailable(ActionList.freezeImmediately)">
          Freeze (Immediately)
        </option>
        <option [ngValue]="ActionList.unfreeze"
                *ngIf="actionIsAvailable(ActionList.unfreeze)">
          Unfreeze
        </option>
        <option [ngValue]="ActionList.editStartDate"
                *ngIf="actionIsAvailable(ActionList.editStartDate)">
          Edit Start Date
        </option>
        <option [ngValue]="ActionList.editDaysRemaining"
                *ngIf="actionIsAvailable(ActionList.editDaysRemaining)">
          Edit Number of Days Remaining
        </option>
        <option [ngValue]="ActionList.editAddOns"
                *ngIf="actionIsAvailable(ActionList.editAddOns)">
          Edit Add-Ons
        </option>
        <option [ngValue]="ActionList.reassign"
                *ngIf="actionIsAvailable(ActionList.reassign)">
          Reassign
        </option>
        <option [ngValue]="ActionList.editMembers"
                *ngIf="actionIsAvailable(ActionList.editMembers)">
          Edit Members (Immediately)
        </option>
      </select>
    </div>

    <app-edit-non-recurring-customer-membership-cancel
      *ngIf="selectedAction == ActionList.cancel"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-non-recurring-customer-membership-cancel>

    <app-edit-prepaid-customer-membership-freeze-immediately
      *ngIf="selectedAction == ActionList.freezeImmediately"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-prepaid-customer-membership-freeze-immediately>

    <app-edit-prepaid-customer-membership-unfreeze
      *ngIf="selectedAction == ActionList.unfreeze"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-prepaid-customer-membership-unfreeze>

    <app-edit-customer-membership-start-date
      *ngIf="selectedAction == ActionList.editStartDate"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-customer-membership-start-date>

    <app-edit-prepaid-customer-membership-days-remaining
      *ngIf="selectedAction == ActionList.editDaysRemaining"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-prepaid-customer-membership-days-remaining>

    <app-edit-customer-membership-add-ons-immediately
      *ngIf="selectedAction == ActionList.editAddOns"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-customer-membership-add-ons-immediately>

    <app-reassign-customer-membership
      *ngIf="selectedAction == ActionList.reassign"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-reassign-customer-membership>

    <app-edit-group-membership-members-immediately
      *ngIf="selectedAction === ActionList.editMembers"
      [membership]="membership"
      [savedCallback]="savedCallback"
      [saveClickedObservable]="saveClickedSubject.asObservable()"
      (loadingEvent)="loading = $event"
      (serverErrorEvent)="serverError = $event">
    </app-edit-group-membership-members-immediately>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loading && hasAvailableActions()"
            [disabled]="selectedAction === null"
            [class.disabled]="selectedAction === null"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loading">
      Loading...
    </button>
  </div>

</ng-container>
